// @ts-nocheck
import React, { createContext, useContext, useEffect, useState } from 'react';
import fetchWithAuth from '../utils/fetchWithAuth.ts';
import { apiConfig } from '../config.js';
import { NOTIFICATIONS_PAGE_SIZE } from '../config.js';

let _refreshNotifications = async () => {}; // initially dummy

const NotificationContext = createContext({
  notifications: [],
  unreadCount: 0,
  isLoading: true,
  refreshNotifications: async () => {},
  markRead: async (v: string) => {},
});

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  async function refreshNotifications() {
    setIsLoading(true);
    try {
      const page = 1;
      const res = await fetchWithAuth(
        `/api/notifications?page=${page}&limit=${NOTIFICATIONS_PAGE_SIZE}`
      );
      const { notifications: newNotifications = [] } = res;

      setNotifications(newNotifications);
      const unread = Array.isArray(newNotifications)
        ? newNotifications.filter((n) => !n.isRead).length
        : 0;

      setUnreadCount(unread);

      setUnreadCount(unread);
    } catch (err) {
      console.error('Failed to load notifications', err);
    } finally {
      setIsLoading(false);
    }
  }

  // Expose refreshNotifications globally
  _refreshNotifications = refreshNotifications;

  async function markRead(notificationId) {
    try {
      await fetchWithAuth(`/api/notifications/${notificationId}/read`, {
        method: 'PATCH',
      });

      setNotifications((prev) => {
        if (!Array.isArray(prev)) return prev;
        return prev.map((n) =>
          n.id === notificationId ? { ...n, isRead: true } : n
        );
      });

      setUnreadCount((prev) => Math.max(0, prev - 1));
    } catch (err) {
      console.error('markRead failed', err);
    }
  }

  useEffect(() => {
    refreshNotifications();

    const interval = setInterval(() => {
      refreshNotifications();
    }, 30000); // every 30 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        unreadCount,
        isLoading,
        refreshNotifications,
        markRead,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotifications() {
  return useContext(NotificationContext);
}

export { _refreshNotifications as refreshNotifications };
